import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { AgentousLogo } from '@/assets/images';
import bgImage from '@/assets/images/onboarding-bg-image.png';
import { ROUTES } from '@/constants/routes';

export default function NewPasswordContainer({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div
      style={{ backgroundImage: `url(${bgImage})` }}
      className="relative mx-auto flex min-h-screen max-w-full justify-center overflow-x-hidden bg-cover"
    >
      <Link className="absolute left-[7%] top-[5%]" to={ROUTES.HOME}>
        <div className="min-w-[80px] max-w-[117px]">
          <img loading="lazy" src={AgentousLogo} className={`h-full w-full`} />
        </div>
      </Link>
      {children}
    </div>
  );
}
